import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgHeart = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-1 -1 20 18"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="none"
        stroke="#7A8B99"
        strokeWidth={1.5}
        d="M9.51 1.474 9 1.991l-.51-.517a4.938 4.938 0 0 0-7.038 0 5.124 5.124 0 0 0 0 7.147l5.392 5.476a3.025 3.025 0 0 0 4.312 0l5.392-5.475a5.124 5.124 0 0 0 0-7.148 4.939 4.939 0 0 0-7.039 0Z"
      />
    </svg>
  );
};
export default SvgHeart;
